import React from "react";
import { styled } from "theme/default/styled";

export const SHeaderLogo = styled.div<{ isFinOnDelivery?: boolean; isArabic?: boolean } & React.ButtonHTMLAttributes<HTMLButtonElement>>`
  width: ${({ isArabic }) => (isArabic ? "190px" : "119px")};
  height: ${({ isFinOnDelivery }) => (isFinOnDelivery ? "50px" : "38px")};
`;
